import { language } from '../stores';
import texts from './Texts';

export const locales = Object.keys(texts);
const warned = [];

function getText(locale, key, vars) {
    if (!key) {
        console.error('getText was called with no key');

        return '';
    }

    if (!locale || !locales.includes(locale)) {
        console.warn('getText was called with unknown locale ' + locale);
        locale = 'en-GB';
    }

    // Grab the translation from the texts object.
    let text = texts[locale][key];

    if (!text) {
        if (!warned.includes(key)) {
            console.warn('no text found for key=' + key);
            warned.push(key);
        }

        text = texts['en-GB'][key];

        if (!text) {
            text = key;
        }
    }

    // Replace any passed in variables in the translation string.
    if (vars) {
        for (let i = 0; i < vars.length; i++) {
            text = text.replace(`{${i}}`, vars[i]);
        }
    }

    return text;
}

/**
 * Return localized text
 * @param {String} key The key for the text, as found in Texts.js  (e.g. 'Question_type')
 * @param {Array} vars optional array of values to replace (text can contain {0} {1} etc)
 * @returns {String} return localized text
 */
export const txt = (key, vars = []) => getText(language, key, vars);
